import { useRouter } from "next/router";
import dragonlordslair from "public/images/DragonlordsLair.png";
import charm from "public/images/LuckyCharm.png";
import sorc from "public/images/SorcererArt.jpg";
import { BiMenu } from "react-icons/bi";

import {
  FeatureNavListItem,
  Header,
  InternalLink,
  Line,
  NavLink,
  NavListItem,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuTrigger,
  SecondaryNavLink,
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@sorcery/ui";

// import { edt } from "@sorcery/utils/universal/time";

import { useUser } from "~/providers/UserProvider";
import {
  accountPath,
  allCardsPath,
  artPath,
  arthurianPath,
  authenticatePath,
  becomeARetailerPath,
  betaPath,
  curiosaPath,
  dragonlordPath,
  eventsPath,
  formatsPath,
  homePath,
  howToPlayPath,
  locatorPath,
  loginPath,
  logoutPath,
  newsItemPath,
  newsPath,
  organizedPlayPath,
  shopPath,
} from "~/utils/paths";
import { Logo } from "../atoms/Logo";

// const arthurianRelease = edt("2024-10-04T00:00:00");

export const HeaderDecorator = () => {
  const { user } = useUser();
  const { asPath } = useRouter();

  return (
    <Header
      logo={
        <div className="w-[8rem] cursor-pointer sm:w-[10rem] md:w-[11rem]">
          <InternalLink href={homePath}>
            <Logo />
          </InternalLink>
        </div>
      }
      leftLinks={
        <>
          <NavigationMenuItem>
            <NavigationMenuTrigger>Game</NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="grid w-[490px] grid-cols-[.9fr_1.1fr] gap-3 p-6">
                <FeatureNavListItem
                  path={howToPlayPath}
                  label="How To Play"
                  subtitle="Rules & Guides"
                  src={sorc}
                />
                <NavListItem path={allCardsPath} label="Cards" subtitle="Sorcery Card Library" />
                <NavListItem
                  path={formatsPath}
                  label="Formats"
                  subtitle="Constructed, Sealed & Draft"
                />
                <NavListItem
                  className="mb-1"
                  path={newsItemPath("dust-in-sorcery-contested-realm")}
                  label="The Dust System"
                  subtitle="Earn Promos and Rewards"
                />
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavigationMenuTrigger>Product</NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="grid w-[490px] grid-cols-[.9fr_1.1fr] gap-3 p-6">
                <FeatureNavListItem
                  path={dragonlordPath}
                  label="Dragonlord"
                  subtitle="Released Aug 2025"
                  src={dragonlordslair}
                />
                <NavListItem
                  label="Arthurian Legends"
                  path={arthurianPath}
                  subtitle="Released Oct 2024"
                />
                <NavListItem
                  label="Beta Edition"
                  path={betaPath}
                  subtitle="Released Nov 2023"
                  className="border-b border-gray-300 border-opacity-30 pb-5"
                />
                <NavListItem
                  className="pb-[13px]"
                  label="Become a Retailer"
                  path={becomeARetailerPath}
                  subtitle="SKU's & Distributors"
                />
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavigationMenuTrigger>Play</NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="grid w-[490px] grid-cols-[.9fr_1.1fr] gap-3 p-6">
                <FeatureNavListItem
                  path={curiosaPath}
                  label="Deckbuilder"
                  subtitle="Explore Curiosa"
                  src={charm}
                />
                <NavListItem
                  label="Organized Play"
                  path={organizedPlayPath}
                  subtitle="Contest The Realm"
                />
                <NavListItem
                  label="Store Locator"
                  path={locatorPath}
                  subtitle="Find Nearby Stores"
                />
                <NavListItem
                  className="-mb-1.5"
                  path={eventsPath}
                  label="Play Network"
                  subtitle="Find Nearby Events"
                />
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavLink path={artPath} label="Art" />
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavLink path={shopPath} label="Shop" />
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavLink path={newsPath} label="News" />
          </NavigationMenuItem>
          {user && (
            <NavigationMenuItem className="items-center lg:visible lg:flex">
              <div className="cursor-default pl-5 pr-6 text-lg text-big-text-color text-opacity-60 ">
                {"|"}
              </div>
              <SecondaryNavLink path={authenticatePath} label="Redeem Code" />
            </NavigationMenuItem>
          )}
        </>
      }
      rightLinks={
        user ? (
          <NavigationMenuItem className="mt-1 hidden lg:visible lg:flex">
            <NavigationMenuTrigger>
              {user?.username
                ? user.username.slice(0, 12) + (user.username.length > 12 ? " ..." : "")
                : "Account"}
            </NavigationMenuTrigger>

            <NavigationMenuContent>
              <ul className="w-max p-6">
                <NavListItem path={accountPath} label={"My Account"} />
                <NavListItem path={authenticatePath} label={"Redeem Code"} />
                <Line className="-mx-2 mb-2 mt-4 h-1 !bg-gray-300 opacity-30" />
                <NavListItem path={logoutPath} label="Logout" />
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
        ) : (
          <NavigationMenuItem className="mt-1 hidden lg:visible lg:flex">
            <NavLink path={loginPath(asPath)} label="Login" />
          </NavigationMenuItem>
        )
      }
      popup={
        <div className="visible lg:invisible lg:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <button type="button" className="outline-none">
                <BiMenu
                  size={18}
                  aria-haspopup="true"
                  className="-mt-0.5 inline-block transition duration-150 ease-in-out animate-in fade-in group-hover:opacity-60"
                />
                <span
                  className={
                    "select-none pl-1 font-title font-bold transition duration-150 ease-in-out group-hover:opacity-60"
                  }
                >
                  Menu
                </span>
              </button>
            </SheetTrigger>
            <SheetContent className="flex flex-col gap-3 overflow-y-auto">
              {user ? (
                <>
                  <NavLink path={accountPath} label={"My Account"} />
                  <NavLink path={authenticatePath} label="Redeem Code" />
                  <NavLink path={logoutPath} label="Logout" />
                </>
              ) : (
                <NavLink path={loginPath(asPath)} label="Login" />
              )}
              <Line className="my-1 h-1 !bg-gray-300 opacity-30" />
              <NavLink path={howToPlayPath} label="How To Play" />
              <NavLink path={allCardsPath} label="Cards" />
              <NavLink path={formatsPath} label="Formats" />
              <NavLink
                path={newsItemPath("dust-in-sorcery-contested-realm")}
                label="The Dust System"
              />
              <NavLink path={dragonlordPath} label="Dragonlord" />
              <NavLink path={arthurianPath} label="Arthurian Legends" />
              <NavLink path={betaPath} label="Beta Edition" />
              <NavLink path={becomeARetailerPath} label="Become a Retailer" />
              <NavLink path={curiosaPath} label="Deckbuilder" />
              <NavLink path={organizedPlayPath} label="Organized Play" />
              <NavLink path={locatorPath} label="Store Locator" />
              <NavLink path={eventsPath} label="Play Network" />
              <NavLink path={artPath} label="Art" />
              <NavLink path={shopPath} label="Shop" />
              <NavLink path={newsPath} label="News" />
            </SheetContent>
          </Sheet>
        </div>
      }
    />
  );
};
